<template>
<v-card class="ma-2" flat outlined>
    <v-card-title v-html="'Informații Hotel'" />

    <v-divider class="mx-4" />

    <v-card flat>
        <v-card-title class="title font-weight-light" v-html="'Adresă'" />
        <v-card-text>
            <GmapMap :center="position" map-type-id="terrain" :zoom="15" style="width: 100%; height: 350px">
                <GmapMarker v-model="position" :position="position" :clickable="false" :draggable="false" />
            </GmapMap>
        </v-card-text>
        <v-card-text class="pt-0">
            <div>
                <v-icon class="mr-2" small>where_to_vote</v-icon>
                {{ hotel.address }}
            </div>
            <div>
                <v-icon class="mr-2" small>phone</v-icon>
                {{ hotel.phone }}
            </div>
            <div>
                <v-icon class="mr-2" small>email</v-icon>
                {{ hotel.email }}
            </div>
        </v-card-text>
    </v-card>

    <v-divider class="mx-4" />

    <v-card flat>
        <v-card-title class="title font-weight-light" v-html="'Galerie'" />
        <v-card-text>
            <v-row no-gutters>
                <v-col cols="12" class="mb-2">
                    <v-img :src="image?image:hotel_image" :aspect-ratio="16/9" />
                </v-col>
                <v-col cols="12">
                    <v-slide-group v-model="model" center-active mandatory show-arrows>
                        <v-slide-item v-for="(media, index) in hotel.images" :key="index" v-slot:default="{ active, toggle }">
                            <v-img :src="media.url.small" :style="{width: '80px', height: '45px'}" :aspect-ratio="16/9" class="mx-1" @click="toggle();image = media.url.original">
                                <v-row class="fill-height" align="center" justify="center">
                                    <v-scale-transition>
                                        <v-icon v-if="active" color="white" v-text="'mdi-camera'" />
                                    </v-scale-transition>
                                </v-row>
                            </v-img>
                        </v-slide-item>
                    </v-slide-group>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>

    <v-divider class="mx-4" />

    <v-card flat>
        <v-card-title class="title font-weight-light" v-html="'Facilități'" />
        <v-card-text v-if="translations">
            <v-chip v-for="(facility, index) in hotel.static.facilities" :key="index" small class="ma-1">
                {{ getFacility(facility) }}
            </v-chip>
        </v-card-text>
    </v-card>

    <v-divider class="mx-4" />

    <v-card flat>
        <v-card-title class="title font-weight-light" v-html="'Detalii'" />
        <v-card-text v-if="hotel.description&&hotel.description.ro" v-html="hotel.description.ro.replace(/(?:\r\n|\r|\n)/g, '<br/>')" />
        <v-card-text>
            Duis sit amet lorem libero. Curabitur ut mollis lacus, dictum mollis nunc. Nunc nec pretium tellus, ultrices maximus augue. Mauris justo nulla, semper et porttitor et, auctor sed neque. Nam malesuada risus id faucibus luctus. Suspendisse
            potenti. Curabitur quis accumsan risus. Fusce nec ante id quam tincidunt dapibus non at enim. Curabitur efficitur lectus quis euismod tincidunt. Nullam rhoncus dapibus velit, sed elementum nibh mattis eget. Aliquam et ligula porta,
            finibus odio a, venenatis justo. Fusce dapibus velit sem, vel mollis diam pellentesque eget. Cras nec tincidunt metus, id sagittis sem. Phasellus eget sapien quis risus tempor venenatis. Vivamus sit amet lectus tincidunt, facilisis sem
            eu, viverra felis. Vestibulum porttitor, ipsum eget ultrices tristique, lacus neque aliquam lorem, eget interdum nisl mi in lorem.
        </v-card-text>
    </v-card>

    <v-divider class="mx-4" />

    <v-card flat>
        <v-card-title class="title font-weight-light" v-html="'Termeni'" />
        <v-card-text v-if="hotel.description&&hotel.description.ro" v-html="hotel.terms.ro.replace(/(?:\r\n|\r|\n)/g, '<br/>')" />
        <v-card-text v-else>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur nisl tortor, efficitur ac maximus ac, sodales nec velit. Suspendisse pretium nibh at scelerisque vulputate. Aliquam quis enim fringilla, sagittis dolor id, porttitor
            ante. Vestibulum urna tortor, consequat in elementum at, efficitur tempor eros. Etiam quis risus ipsum. Vivamus quis ipsum eu nibh efficitur bibendum. Sed semper sem nec placerat pellentesque. Vivamus et dolor neque.
        </v-card-text>
    </v-card>

</v-card>
</template>

<script>
import defaultImage from "@/assets/hotel.jpeg";
import {
    getTranslations
} from "@/api/Translations";

export default {
    props: {
        hotel: {
            type: Object,
            default: () => null
        }
    },

    created() {
        this.image = this.hotel.images[0] ? this.hotel.images[0].url : defaultImage;
        this.position = {
            lat: Number(this.hotel.static.location.geo.lat),
            lng: Number(this.hotel.static.location.geo.lon)
        };

    },

    data: () => ({
        model: null,
        image: null,
        hotel_image: defaultImage,
        position: null,
        translations: null
    }),

    methods: {

    }
}
</script>
